/* This file depends on having archive available. */
/* global recipe_label, formatter_data, simplified_hash, optional_vitamins, optional_vitamins_2, aggregate_vitamins */

import jQuery from "jquery";
Object.assign(globalThis, { jQuery });

const $ = jQuery;
const Confirm = global.Confirm;

import "jquery-ui/ui/core";
import "jquery-ui/ui/widgets/slider";

import { isEqual } from "lodash-es";

import {
  selectedFormat,
  isFormat,
  isFDA,
  isLegacyFDA,
  isCanadian,
  isChild,
  isInfant,
} from "./format.js";

import { NUTRITION_FACTS_PANEL_SELECTOR, syntheticEvent } from "./util.js";
import { readySignal } from "./ready_signal.js";
import { exposeWidth } from "./expose_width.js";
import { recipeId, canSave, saveLabel, saveRecipe, saveProteinScore, setSaveEnabled } from "./persistence.js";
import { withoutFx, clickUnlessChecked, getLocales } from "./util.js";
import { showLanguages } from "./language.js";
import { adjustNewLinearLineHeightForCalorieFont, adjustDailyValueHeight } from "./layout.js";
import { simplify, setSimplified } from "./simplified.js";
import { minifyAsteriskSection } from "./recipe_option_toggles.js";

import { initializeSliders, loadSliders, refreshSlider, triggerSliders } from "./sliders.js";
import { initializeTextControls, applyTextStyles, syncTextControlsWithLabel } from "./text_style.js";
import { initializeAPDescriptionControls, syncAsPreparedServingVisibilityWithLabel } from "./as_prepared.js";
import { initializeAggregateControls } from "./aggregate.js";
import { initializeBilingualBreadcumbControl, syncBilingualControlsWithLabel } from "./bilingual.js";

import {
  bindElementsThatImpactInsignificant,
  bindOptionalNutrientPanel,
  toggleAddedSugar,
  toggleOtherCarbohyrate,
  togglePolyMonoUnsaturatedFats,
  togglePotassium,
  toggleSugarAlcohol,
  toggleVariedServings,
  toggleInsignificant,
  insignificantCheckboxForFormat,
  initOptionalNutrientPanel,
  checkAndShowCanadianSugarAlcohol
} from "./optional_nutrient_toggles.js";

import { tabularShuffle } from "./layout.js";

import {
  initializeSections,
  syncDualColumnSliders,
  showClaimsSectionsForLabel,
  applyBioengineeredSection,
  showProperAllergens,
  showProperIngredients,
  hideNewCanadaIngredientsTable,
  showOpenSections
} from "./sections.js";
import { initializeEmbedCode } from "./embed_code.js";
import { applyCompactVitamins, initializeVitaminToggles, getVitaminToggles, updateVitaminToggles, updateVitaminOverrides, rebuildFunction } from "./vitamin_toggles.js";
import { initializeAddresses } from "./addresses.js";

import { once, onceEach } from "jose_modern/once.js";

import {
  manufacturedAtUpdateAllRecipePath,
  newSupplementLabelPath,
  recipePath,
  relatedRecipesRecipePath,
} from "routes";
import { bindOverrides } from "./overrides.js";

const isRenderingSampleLabel = () => document.querySelector("#is-rendering");

document.addEventListener("breakpoint:change", ({ name, matches }) => {
  if (name !== "touch") {
    return;
  }

  let destination;
  if (matches) {
    destination = document.querySelector("#floating-preview-options");
  } else {
    destination = document.querySelector("#sidebar-options-column");
  }

  const optionToggles = document.querySelector('#recipe-option-toggles');
  destination.appendChild(optionToggles);
});

const localesEqual = (v) => {
  return isEqual(locales, v);
};

let sliders = [];
let locales = [];

/* Return a function that syncs a slider as an event handler */
const saveSliderEvent = (sliderId) => {
  return (_event, ui) => {
    sliders[sliderId] = ui.value;
    saveLabel({ sliders });
  };
};

const initializeToggles = () => {
  //Hide optional nutrition facts initially
  function hideOptional() {
    $('.protein-percent.optional, .protein-percent-conversion.optional').hide();
    document.querySelector("#protein-score-container").classList.add("is-hidden");
    $('#potassium, #potassiumhairline, #potassiumpercentconversion, #potassiumpercentconversiontabular, #potassium-aggregate, #potassiumpercentconversionaggregate').hide();
    $('#linearpotassium, #potassiumtabular').hide();
    $('#satfatcalories, #satfatcaloriescanada, #linearsatfatcalories, #satfatcaloriestabular, #satfatcalories-aggregate').hide();
    $('#polyunsatfat, #polyunsatfattabular, #polyunsatfatnewtabular, #polyunsatfat-new-as-prepared, #polyunsatfat-new-aggregate, .new-canada-polyunsaturated, #polyunsaturatednewlinearcanada').hide();
    $('#monounsatfat, #monounsatfattabular, #monounsatfatnewtabular, #monounsatfat-new-as-prepared, #monounsatfat-new-aggregate, .new-canada-monounsaturated, #monounsaturatednewlinearcanada').hide();
    $('#linearunsatfat, #newlinearunsatfat').hide();
    $('#othercarb, #linearothercarb, #othercarbtabular, #othercarb-aggregate').hide();
    $('.added-sugar-grams').show();
    $('#sugaralcohol, #sugaralcohollinear, #sugaralcoholtabular, #sugaralcoholaggregate, #sugaralcoholnewvertical, #sugaralcoholnewtabular, #sugaralcoholnewlinear, #sugaralcoholnewasprepared, #sugaralcoholnewaggregate, .new-canada-sugar-alcohol').hide();
    $('#calorieconversion, #calorieconversiontabular').hide();
    $('#optionalnutrientsdiv, #regularlabeloptions, #optionalvitaminsdiv, #extrasections, #defaultsettingsoptions').hide();
    $('#asterisksection-replace, #asterisksectiontabular-replace, #asterisksection-replace-aggregate').hide();
    $('#insignificant-nutrients-list, #insignificant-nutrients-list-tabular, #insignificant-nutrients-list-new-tabular, #insignificant-nutrients-list-new-linear, #insignificant-nutrients-list-linear, #insignificant-nutrients-list-as-packaged, #insignificant-nutrients-list-new-as-packaged, #insignificant-nutrients-list-new-aggregate').hide();
    $('.servings-per-container-varied').hide();
    if ($('#ingredient-list-toggle').is(':checked')) {
      // do nothing
    } else {
      $('#recipe-show-ingredient-list').show();
      $('.recipe-show-new-canada-ingredient-list').hide();
      $('.recipe-show-new-canada-french-ingredient-list').hide();
    }
    $('.servings-per-container-varied').hide();
    $('.servings-per-container').show();
    $('.servings-per-container-div').show();
  }

  hideOptional();
  adjustServingFontSize();

  function resetLabelSettingsAfterChange() {
    // switch chevrons back to resting position :)
    $('.icon.rotate-90').removeClass("rotate-90");

    if (jQuery("#recipe-option-toggles").hasClass("public-recipe-sidebar")) {
      jQuery("#overrides-chevron").addClass("rotate-90");
    }

    //only move the footnote section back if necessary
    if ($('#asterisksectiontoggle').is(":checked")) {
      $('#asterisksectiontoggle').prop("checked", false);
      moveAsteriskSection();
    }

    //uncheck everything
    $('.toggles :checkbox').not(".keep-checked").prop("checked", false);

    //redo things that weren't aren't changed by simply hiding/showing
    simplify();
    minifyAsteriskSection();

    //reset Canadian labels
    showLanguages();

    //apply the correct text controls for this label type
    syncTextControlsWithLabel();
    syncBilingualControlsWithLabel();
    syncAsPreparedServingVisibilityWithLabel();

    //hide or show jurisdiction specific claims sections
    showClaimsSectionsForLabel();

    //hide or show the bioengineered label
    applyBioengineeredSection();

    //hide everything in case it was shown
    hideOptional();
    showProperAllergens();

    // reset format settings
    saveLabel({
      format: selectedFormat(),
      varied_servings: $('#servings-varied-toggle').is(':checked'),
      show_caloric_conversion: $('#conversiontoggle').is(':checked'),
      move_footnote: $('#asterisksectiontoggle').is(':checked'),
      shorten_footnote: $('#asterisksectionminitoggle').is(':checked'),
      show_sat_fat_calories: $('#satfatcaloriestoggle').is(':checked'),
      show_unsat_fat: $('#polymonounsatfattoggle').is(':checked'),
      show_potassium: $('#potassiumtoggle').is(':checked'),
      show_other_carbs: $('#othercarbtoggle').is(':checked'),
      show_sugar_alcohol: $('#sugaralcoholtoggle').is(':checked'),
      show_protein_percent: $('#protein-percent-toggle').is(':checked'),
      show_added_sugar_grams: !$('#hideaddedsugartoggle').is(':checked'),
      ...getVitaminToggles(),
      locales
    });
  }

  once(document, "initialize-toggles", () => {
    document.addEventListener("partial:replace", (e) => {
      switch (e.partial) {
        case "recipes/label":
          syncDualColumnSliders();
          loadSliders({ sliders });
          rebuildFunction();
          applyCompactVitamins($('#compact-vitamins').is(':checked'));
          $('#compact-vitamins-container').toggle($('#newdualnutritionfactstable').length === 0);
          toggleAddedSugar(!$('#hideaddedsugartoggle').is(':checked'));
          toggleCaloricConversion($('#conversiontoggle').is(':checked'));
          toggleOtherCarbohyrate($('#othercarbtoggle').is(':checked'));
          togglePolyMonoUnsaturatedFats($('#polymonounsatfattoggle').is(':checked'));
          togglePotassium($('#potassiumtoggle').is(':checked'));
          toggleSingleServing($('#single-serving-toggle').is(':checked'));
          toggleSugarAlcohol($('#sugaralcoholtoggle').is(':checked'));
          toggleVariedServings($('#servings-varied-toggle').is(':checked'));
          simplify({updateControls: false});
          showLanguages();
          syncBilingualControlsWithLabel();
          syncAsPreparedServingVisibilityWithLabel();
          syncTextControlsWithLabel();
          toggleInsignificant(insignificantCheckboxForFormat()?.is(":checked"));
          if ($('#asterisksectiontoggle').is(":checked")) {
            moveAsteriskSection();
          }
          minifyAsteriskSection();
          break;

        case "recipes/sidebar_nutrition_overrides":
          // - bindOverrides does not need to be called here to re-bind since we are using event delegation now.
          // - for public recipe cases, since bilingual fields are shown in the overrides panel, we may need to re-bind language toggle.
          initializeBilingualBreadcumbControl();
          rebuildFunction();
          break;

        case "recipes/sidebar_optional_nutrients":
          if (recipe_label.show_insignificant) {
            insignificantCheckboxForFormat()?.prop("checked", true);
          }
          initOptionalNutrientPanel(recipe_label);
          bindOptionalNutrientPanel();
          break;

        case "recipes/fda_nutrition_claims":
          $("#nutrition-claims").toggle(isFDA());
          break;

        case "recipes/recipe_ingredients_and_allergens":
          showProperIngredients();
          showProperAllergens();
          syncTextControlsWithLabel();
          break;

        case "recipes/ca_fop_download":
          $("#canada-fop-symbols").toggle(isCanadian());
          break
      }
    });
  });

  //
  // ========== When change label type changes ============ //
  //

  function labeltype_change_callbacks() {
    sliders = recipe_label.sliders ?? [];
    locales = recipe_label.locales ?? [];

    if (isFormat("legacy_fda/adult/linear")) {
      $('#linearnutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
      });
      $('#child-claims-note:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("fda/adult/linear")) {
      $('#newlinearnutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        adjustNewLinearLineHeightForCalorieFont();
        rebuildFunction();
      });
      $('#child-claims-note:visible, #nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#new-nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("fda/adult/vertical")) {
      $('#newnutritionfactstable, #newdualnutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        // need it in callback function bc otherwise it's not there and width is 0
        adjustServingFontSize();
        rebuildFunction();
      });
      $('#child-claims-note:visible, #nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#new-nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("canada/adult/vertical")) {
      $('#child-claims-note:visible, #nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#new-nutrition-claims-content').fadeIn('slow');
      });
      $('#newcanadanutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
        showProperAllergens();
        showProperIngredients();
        // required to be upper and lowercase, can't be all lower or upper
        $('#remove-uppercase-toggle').trigger("click");

        // mandatory to show sugar alcohol for canadian labels if present
        checkAndShowCanadianSugarAlcohol();
      });
    } else if (isFormat("canada/adult/linear")) {
      $('#child-claims-note:visible, #nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#new-nutrition-claims-content').fadeIn('slow');
      });
      $('#newlinearcanadanutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
        showProperAllergens();
        showProperIngredients();
        // required to be upper and lowercase, can't be all lower or upper
        $('#remove-uppercase-toggle').trigger("click");

        // mandatory to show sugar alcohol for canadian labels if present
        checkAndShowCanadianSugarAlcohol();

        // default to english only, only if not already checked though
        if (localesEqual(["en-CA"])) {
          clickUnlessChecked("#canada-english-only-toggle");
        } else if (localesEqual(["fr-CA"])) {
          clickUnlessChecked("#canada-french-only-toggle");
        }
      });
    } else if (isFormat("canada/adult/tabular")) {
      $('.CaTabularNFP, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
        showProperAllergens();
        showProperIngredients();

        // required to be upper and lowercase, can't be all lower or upper
        $('#remove-uppercase-toggle').trigger("click");

        // mandatory to show sugar alcohol for canadian labels if present
        checkAndShowCanadianSugarAlcohol();
      });
    } else if (isFormat("canada/adult/vertical/as_prepared")) {
      $('.CaDualFormatNFP').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
        showProperAllergens();
        showProperIngredients();
      });

      // mandatory to show sugar alcohol for canadian labels if present
      checkAndShowCanadianSugarAlcohol();

      if (document.querySelector('.CaDualFormatNFP') === null) {
        // Label isn't loaded, show related recipes modal to select 'as prepared' recipe
        $.get(relatedRecipesRecipePath(recipeId()),
          { recipe_label: { format: selectedFormat() } }
        );
      }

      $('#load-as-prepared-label-recipe-modal').show();
    } else if (isFormat("canada/adult/vertical/aggregate")){
      $('.CaAggregate').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
        showProperAllergens();
        showProperIngredients();
      });

      // mandatory to show sugar alcohol for canadian labels if present
      checkAndShowCanadianSugarAlcohol();

      if (aggregate_vitamins.length == 1) {
        $.get(relatedRecipesRecipePath(recipeId()),
          { recipe_label: { format: selectedFormat() } },
          "script"
        );
      }

      $('#load-aggregate-label-recipe-modal').show();
    } else if (isFormat("legacy_fda/adult/vertical")) {
      $('.nutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        showProperIngredients();
        rebuildFunction();
      });
      $('#child-claims-note:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("legacy_fda/adult/tabular")) {
      $('#tabularnutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        tabularShuffle();
        rebuildFunction();
      });
      $('#child-claims-note:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("fda/adult/tabular")) {
      $('#newtabularnutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        // rebuildFunction and tabularShuffle have dependencies on the rendered DOM.  jQuery
        // effects allow rebuildFunction to capture the client size of the nutrient array before
        // it has settled.
        //
        // This exhibits as a vitamin section that wraps differently on reload than after a
        // slider event.
        //
        // There are probably other similar issues lurking in other formats.  This hack is in
        // direct response to a customer ticket in this format.
        setTimeout(() => {
          tabularShuffle();
          rebuildFunction();
        }, 1);
      });
      $('#child-claims-note:visible, #nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#new-nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("legacy_fda/adult/vertical/as_prepared")) {
      $('.aggregatenutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
      });
      // get modal and recipe results to select a second recipe to go off of
      // but only if there isn't a second recipe there (based on if aggregate table is rendered or not)
      if ($('.aggregatenutritionfactstable').length > 0) {
        // do nothing
      } else { // get modal and select from recipes

        $.get(relatedRecipesRecipePath(recipeId()),
          { recipe_label: { format: selectedFormat() } },
          "script"
        );
      }
      // do this either way
      $('#load-as-prepared-label-recipe-modal').show();
      $('#child-claims-note:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("fda/adult/vertical/as_prepared")) {
      $('#newaspreparednutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
        adjustDualServingSizeLineHeight();
      });
      // get modal and recipe results to select a second recipe to go off of
      // but only if there isn't a second recipe there (based on if aggregate table is rendered or not)
      if ($('#newaspreparednutritionfactstable').length > 0) {
        // do nothing
      } else { // get modal and select from recipes
        $.get(relatedRecipesRecipePath(recipeId()),
          { recipe_label: { format: selectedFormat() } }
        );
      }
      // do this either way
      $('#load-as-prepared-label-recipe-modal').show();
      $('#child-claims-note:visible, #nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#new-nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("fda/adult/vertical/aggregate")) {
      $('#newaggregatenutritionfactstable, #nutrientsslidedown:hidden').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
        adjustDualServingSizeLineHeight();
        showAggregateRecipeTitles();
      });
      if (aggregate_vitamins.length == 1) {
        $.get(relatedRecipesRecipePath(recipeId()),
          { recipe_label: { format: selectedFormat() } },
          "script"
        );
      }
      $('#load-aggregate-label-recipe-modal').show();
      $('#child-claims-note:visible, #nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#new-nutrition-claims-content').fadeIn('slow');
      });
    } else if (isFormat("legacy_fda/infant/vertical")) {
      $('#nutrientsslidedown:visible').fadeOut('slow');
      $('#infantnutritionfactstable').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
      });
      $('#nutrition-claims-content:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#child-claims-note').fadeIn('slow');
      });
    } else if (isFormat("legacy_fda/child/vertical")) {
      $('#nutrientsslidedown:visible').fadeOut('slow');
      $('#childnutritionfactstable').fadeIn('slow', () => {
        resetLabelSettingsAfterChange();
        rebuildFunction();
      });
      $('#nutrition-claims-content:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#child-claims-note').fadeIn('slow');
      });
    } else if (isFormat("fda/infant/vertical")) {
      $('#nutrientsslidedown:visible').fadeOut('slow');
      $('#newinfantnutritionfactstable').fadeIn('slow', () => { // need it in callback function bc otherwise it's not there and width is 0
        resetLabelSettingsAfterChange();
        adjustServingFontSize();
        rebuildFunction();
      });
      $('#nutrition-claims-content:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#child-claims-note').fadeIn('slow');
      });
    } else if (isFormat("fda/child/vertical")) {
      $('#nutrientsslidedown:visible').fadeOut('slow');
      $('#newchildnutritionfactstable').fadeIn('slow', () => { // need it in callback function bc otherwise it's not there and width is 0
        resetLabelSettingsAfterChange();
        adjustServingFontSize();
        rebuildFunction();
      });
      $('#nutrition-claims-content:visible, #new-nutrition-claims-content:visible').fadeOut('slow', () => {
        $('#child-claims-note').fadeIn('slow');
      });
    }

    if ((isFDA() || isLegacyFDA()) && (isChild() || isInfant())) {
      $('#protein-score-container-required').fadeIn('slow');
    } else {
      $('#protein-score-container-required').fadeOut('slow');
    }

    setSimplified(recipe_label.simplified);
  }

  once(document.querySelector("#labeltype"), "label-type", () => {
    let previousLabelType = $('#labeltype').val();

    $('#labeltype').on("change", () => {
      const selected = selectedFormat();

      if (selected === "fda_supplement") {
        // Revert dropdown — this isn't a real label format
        $('#labeltype').val(previousLabelType);

        // Open a new supplement label in a new tab, pre-loaded with import from this recipe
        const url = newSupplementLabelPath() + "?import_recipe_id=" + recipeId();
        window.open(url, "_blank");
        return;
      }

      previousLabelType = selected;

      $('#load-as-prepared-label-recipe-modal').hide();
      $('#load-aggregate-label-recipe-modal').hide();

      $('#label-loader').show();
      $('#label').addClass('is-loading');

      $.get(recipePath(recipeId()),
        { recipe_label: { format: selectedFormat() } },
        () => { },
        "script"
      ).done(() => {
        $('#label-loader').hide();
        $('#label').removeClass('is-loading');

        saveLabel({format: selectedFormat()});
      });
    });
  });

  function adjustDualServingSizeLineHeight() {
    // first hide filler line, compare heights, show shorter column filler line if heights unequal
    $('.dual-per-serving-extra-line').hide();
    const package_height = $('.dual-per-serving-line:visible').first().height();
    const serving_height = $('.dual-per-serving-line:visible').last().height();
    if (serving_height > package_height) {
      $('.dual-per-serving-line:visible').first().next().show();
    } else if (serving_height < package_height) {
      $('.dual-per-serving-line:visible').last().next().show();
    }
  }

  once(document, "dual-serving-size-line", () => {
    document.addEventListener("label:dual-serving-line-changed", adjustDualServingSizeLineHeight);
  });

  $(`#suggested-serving, #suggested-serving-french,
     #as-prepared-suggested-serving, #as-prepared-suggested-serving-french,
     [data-aggregate-serving-input]`).on("change", (event) => {
    saveRecipe({ [event.target.name]: event.target.value }, event.target.dataset['recipe']);
  });

  function showAggregateRecipeTitles() {
    if ($('#ingredient-list-toggle').is(':checked') && $('#allergen-list-toggle').is(':checked')) {
      $('.agg-ingredient-list-recipe-name, .ca-agg-ingredient-list-recipe-name').hide();
    } else {
      $('.agg-ingredient-list-recipe-name, .ca-agg-ingredient-list-recipe-name').hide();
      if (isCanadian()) {
        $('.ca-agg-ingredient-list-recipe-name').show();
      } else {
        $('.agg-ingredient-list-recipe-name').show();
      }
    }
  }

  //Show calorie conversion on button click
  $('#conversiontoggle').on("click", (e) => {
    toggleCaloricConversion(e.target.checked);

    saveLabel({ show_caloric_conversion: e.target.checked });
  });

  function toggleCaloricConversion(display) {
    // logic for both showing and hiding
    if (isFormat("legacy_fda/adult/vertical")) {
      if (display) {
        $("#calorieconversion").fadeIn("slow");
      } else {
        $("#calorieconversion").fadeOut("fast");
      }
    } else if (isFormat("legacy_fda/adult/tabular")) {
      if (display) {
        $("#calorieconversiontabular").fadeIn("slow");
      } else {
        $("#calorieconversiontabular").fadeOut("fast");
      }
    } else if (isFormat("legacy_fda/adult/vertical/as_prepared")) {
      if (display) {
        $("#calorieconversionaggregate").fadeIn("slow");
      } else {
        $("#calorieconversionaggregate").fadeOut("fast");
      }
    }
  }

  //Move asterisk section
  $('#asterisksectiontoggle').on("click", () => {
    moveAsteriskSection();

    saveLabel({ move_footnote: $('#asterisksectiontoggle').is(':checked') });
  });

  function moveAsteriskSection() {
    // logic for moving asterisk section
    if (isFormat("legacy_fda/adult/vertical")) {
      if ($('#asterisksectiontoggle').is(":checked") && $('.nutritionfactstable').length == 1) {
        $('.asterisksection').insertAfter('.nutritionfactstable');
        $('.asterisksection').wrap('<div class="nutritionfactstable" />');
      } else if ($('.nutritionfactstable').length > 1) {
        $('.asterisksection').unwrap('<div class="nutritionfactstable" />');
        $('.asterisksection').appendTo('.nutritionfactstable');
      }
      $('.nutritionfactstable').css('color', $('#regularlabel-color').val());
      $('.nutritionfactstable').css('background-color', $('#regularlabel-backgroundcolor').val());
      refreshSlider("#standardslider");
    } else if (isFormat("legacy_fda/adult/vertical/as_prepared")) {
      if ($('#asterisksectiontoggle').is(":checked") && $('.aggregatenutritionfactstable').length == 1) {
        $('.asterisksectionaggregate').insertAfter('.aggregatenutritionfactstable');
        $('.asterisksectionaggregate').wrap('<div class="aggregatenutritionfactstable" />');
      } else if ($('.aggregatenutritionfactstable').length > 1) {
        $('.asterisksectionaggregate').unwrap('<div class="aggregatenutritionfactstable" />');
        $('.asterisksectionaggregate').appendTo('.aggregatenutritionfactstable');
      }
      $('.aggregatenutritionfactstable').css('color', $('#regularlabel-color').val());
      $('.aggregatenutritionfactstable').css('background-color', $('#regularlabel-backgroundcolor').val());
      refreshSlider("#aggregateslider");
    }
  }

  //Simplified label format
  $('#simplifiedformattoggle, #newsimplifiedformattoggle, #newaggregatesimplifiedformattoggle, #newcanadasimplifiedformattoggle').on("change", (ev) => {
    const alsoShortenFootnote = !syntheticEvent(ev);
    setSimplified($(ev.target).is(":checked"), { updateControls: alsoShortenFootnote });

    saveLabel({
      simplified: $(ev.target).is(":checked"),
      shorten_footnote: $('#asterisksectionminitoggle').is(":checked")
    });
  });

  bindOptionalNutrientPanel();
  bindElementsThatImpactInsignificant("#optionalvitaminsdiv input:checkbox")

  //Replace asterisk section with mini version
  $('#asterisksectionminitoggle').on("click", () => {
    minifyAsteriskSection();
    saveLabel({ shorten_footnote: $('#asterisksectionminitoggle').is(':checked') });
  });

  // hide h2 recipe title for printing purposes
  $('#recipe-title-toggle').on("click", () => {
    const recipeTitle = $('#recipe-title, .printlike-recipe-title');
    const isRendering = document.querySelector('#is-rendering') !== null;

    if ($('#recipe-title-toggle').is(':checked')) {
      recipeTitle.addClass('recipe-title-hidden');
      if (!isRendering) {
        recipeTitle.attr('title', 'Hiding recipe title: it will not be included in the downloaded PDF/PNG');
      }
    } else {
      recipeTitle.removeClass('recipe-title-hidden');
      if (!isRendering) {
        recipeTitle.removeAttr('title');
      }
    }

    saveLabel({ show_title: !$('#recipe-title-toggle').is(':checked') });
  });

  // hide the nutrition facts (label) for printing
  $('#nutrition-facts-toggle').on("click", () => {
    const hide = $('#nutrition-facts-toggle').is(':checked');
    if (hide) {
      $(NUTRITION_FACTS_PANEL_SELECTOR).css('visibility', 'hidden').css('position', 'absolute')
    } else {
      $(NUTRITION_FACTS_PANEL_SELECTOR).css('visibility', 'visible').css('position', '')
    }
    $('.manual-nutrition-adjustments-warning').toggleClass('is-hidden', hide);

    saveLabel({ show_nutrition_facts: !hide });
  });

  // hide ingredient list for printing purposes
  $('#ingredient-list-toggle').on("click", () => {
    const hide = $('#ingredient-list-toggle').is(':checked');
    showProperIngredients();
    showAggregateRecipeTitles();
    $('.locked-ingredient-list-warning').toggleClass('is-hidden', hide);
    saveLabel({ show_ingredient_list: !hide });
  });

  const languageToggleSelectors = [
    '#canada-english-only-toggle', '#canada-french-only-toggle', '#reverse-language-toggle'
  ];
  languageToggleSelectors.forEach((selector) => (
    document.querySelector(selector).addEventListener("click", (ev) => {
      // When one language option is checked uncheck the others
      languageToggleSelectors.forEach((id) => {
        const el = document.querySelector(id);
        if (ev.target !== el) {
          el.checked = false;
        }
      });

      showLanguages();
      syncBilingualControlsWithLabel();
      saveLabel({ locales: getLocales() });
    })
  ));

  // hide allergen list for printing purposes
  $('#allergen-list-toggle').on("click", () => {
    const hide = $('#allergen-list-toggle').is(':checked');
    if (hide) {
      $('#allergen-list, .allergen-list-canada-english, .allergen-list-canada-french, .agg-allergen-list').hide();
      hideNewCanadaIngredientsTable();
      showAggregateRecipeTitles();
    } else {
      $('#new-canada-ingredients-allergens-table').show();
      showProperAllergens();
      hideNewCanadaIngredientsTable();
      showAggregateRecipeTitles();
    }
    $('.locked-allergen-warning').toggleClass('is-hidden', hide);

    saveLabel({ show_allergens: !hide });
  });

  // hide facility allergen list for printing purposes
  $('#facility-allergen-list-toggle').on("click", () => {
    const hide = $('#facility-allergen-list-toggle').is(':checked');
    if (hide) {
      $('#facility-allergen-container').hide();
      showProperAllergens();
      hideNewCanadaIngredientsTable();
    } else {
      $('#new-canada-ingredients-allergens-table').show();
      $('#facility-allergen-container').show();
      showProperAllergens();
      hideNewCanadaIngredientsTable();
    }
    $('.redundant-facility-allergens-warning').toggleClass('is-hidden', hide);

    saveLabel({ show_facility_allergens: !hide });
  });

  // hide business name/address for printing purposes
  $('#manufactured-at-toggle').on("click", () => {
    const hide = $('#manufactured-at-toggle').is(':checked');
    $('#manufacture-address').toggle(!hide);
    saveLabel({ show_business_info: !hide });
  });

  // hide bioengineered claim for printing
  $('#bioengineered-toggle').on("click", () => {
    if ($('#bioengineered-toggle').is(':checked')) {
      $('#bioengineered-claim, .bioengineered-food').hide();
    } else {
      $('#bioengineered-claim, .bioengineered-food').show();
    }

    saveLabel({ show_bioengineered: !$('#bioengineered-toggle').is(':checked') });
  });

  // display as bioengineered food for printing
  $('#bioengineered-food-toggle').on("click", () => {
    const displayFood = $('#bioengineered-food-toggle').is(':checked');

    $('#bioengineered-claim .bioengineered-claim-food').toggle(displayFood);
    $('#bioengineered-claim .bioengineered-claim-ingredients').toggle(!displayFood);

    saveLabel({ bioengineered_food: displayFood });
  });

  // set manufactured_at text across all recipes in account
  $('#manufacture-address-options-update-all').on("click", () => {
    $.post(manufacturedAtUpdateAllRecipePath(recipeId()),
      { manufactured_at: $('#recipe_manufactured_at').val() }
    );
  });

  // show/hide the options for using saved addresses
  let addressOptionsVisible = false;
  $('#address-options-toggle').on("click", ({ target }) => {
    const options = $('#manufacture-address-options');

    // Update the state, then transition based on that state
    addressOptionsVisible = !addressOptionsVisible;
    if (addressOptionsVisible) {
      target.textContent = "Hide Address Options";
      options.slideDown(350);
    } else {
      target.textContent = "Show Address Options";
      options.slideUp(350);
    }
  });

  // New serving size line is bigger text, so can make it smaller if it doesn't fit on one line
  function adjustServingFontSize(depth = 0) {
    if (depth > 30) {
      /* This case usually means we're caught in inifinite recursion: we're altering the
         font-size, but the browser has clamped us on one end or the other (e.g., Chrome's minimum
         font-size advanced setting.) */
      const msg = `
        Your browser's font settings do not allow us to display labels with proper font sizes.
        Please check your browser for any minimum font size settings and set them to the lowest option.
      `;
      Confirm.confirm(msg, { cancel: null, confirm: "OK" });
      return;
    }

    const div_width = $('.servingsizenew-bold:visible').width();
    const element_width_sum = $('.servingsizenew-bold:visible :nth-child(1)').width() + $('.servingsizenew-bold:visible :nth-child(2)').width();
    const current_font_size = parseInt($('.servingsizenew-bold:visible').css('font-size'));
    // if no room and font is more than 11px (min allowed size)
    if ((element_width_sum / div_width > 0.95) && (current_font_size > 11)) {
      $('.servingsizenew-bold:visible').css('font-size', parseInt($('.servingsizenew-bold:visible').css('font-size')) - 1 + "px");
      $('.servingsizenew-bold:visible').css('line-height', parseInt($('.servingsizenew-bold:visible').css('line-height')) - 1 + "px");
      adjustServingFontSize(depth + 1); // in case 1px less isn't enough
    }
    // making font bigger...
    else if ((element_width_sum / div_width < 0.85) && (current_font_size < 14)) {
      $('.servingsizenew-bold:visible').css('font-size', parseInt($('.servingsizenew-bold:visible').css('font-size')) + 1 + "px");
      $('.servingsizenew-bold:visible').css('line-height', parseInt($('.servingsizenew-bold:visible').css('line-height')) + 1 + "px");
      adjustServingFontSize(depth + 1); // in case 1px less isn't enough
    } else {
      // do nothing
    }
  }

  // varied servings
  $('#servings-varied-toggle').on("click", (e) => {
    toggleVariedServings(e.target.checked);

    saveLabel({ varied_servings: e.target.checked });
  });

  // new single servings (for adjusted_servings)
  $('#single-serving-toggle').on("click", (e) => {
    toggleSingleServing(e.target.checked);

    saveLabel({ single_serving: e.target.checked });
  });

  // option to disable dual column for FDA formats
  $('#disable-dual-column-toggle').on("click", (e) => {
    saveLabel({ disable_dual_column: e.target.checked });
  });

  function toggleSingleServing(display) {
    if (display) {
      $('.servings-per-container-div').hide(() => {
        if (isFormat("fda/adult/linear")) {
          adjustNewLinearLineHeightForCalorieFont();
        }
      });
    } else {
      $('.servings-per-container-div').show(() => {
        if (isFormat("fda/adult/linear")) {
          adjustNewLinearLineHeightForCalorieFont();
        }
      });
    }
  }

  onceEach(document.querySelectorAll("#load-as-prepared-label-recipe-modal"), "ap-recipe-modal", () => {
    $('#load-as-prepared-label-recipe-modal').on("click", () => {
      $.get(relatedRecipesRecipePath(recipeId()),
        { recipe_label: { format: selectedFormat() } },
        "script"
      );
    });
  });

  onceEach(document.querySelectorAll("#load-aggregate-label-recipe-modal"), "agg-recipe-modal", () => {
    $('#load-aggregate-label-recipe-modal').on("click", () => {
      $.get(relatedRecipesRecipePath(recipeId()),
        { recipe_label: { format: selectedFormat() } },
        "script"
      );
    });
  });

  $('#recipe_default_label').on("click", function () {
    if ($(this).is(":checked")) {
      $('.setalltodefaulttoggle').show();
    } else {
      $('.setalltodefaulttoggle').hide();
    }
  })

  function applyNonLabelSpecificSettings() {
    if (!recipe_label.show_title) {
      $('#recipe-title-toggle').trigger("click");
    }
    if (!recipe_label.show_nutrition_facts) {
      $('#nutrition-facts-toggle').trigger("click");
    }
    if (!recipe_label.show_ingredient_list) {
      $('#ingredient-list-toggle').trigger("click");
    }
    if (!recipe_label.show_allergens) {
      $('#allergen-list-toggle').trigger("click");
    }
    if (!recipe_label.show_facility_allergens) {
      $('#facility-allergen-list-toggle').trigger("click");
    }
    if (!recipe_label.show_business_info) {
      $('#manufactured-at-toggle').trigger("click");
    }
    $('#hide-barcode-toggle').prop("checked", recipe_label.hide_barcode);
    $('#hide-logo-toggle').prop("checked", recipe_label.hide_logo);

    const bioengineeredSetOnLabel = recipe_label.show_bioengineered !== null;
    if (isCanadian()) {
      $('#bioengineered-claim').toggle(false);
    } else if (bioengineeredSetOnLabel) {
      $('#bioengineered-claim, .bioengineered-food').toggle(recipe_label.show_bioengineered);
      $('#bioengineered-toggle').prop("checked", !recipe_label.show_bioengineered);
    } else {
      const hideBioengineeredToggled = $('#bioengineered-toggle').is(":checked");
      $('#bioengineered-claim, .bioengineered-food').toggle(!hideBioengineeredToggled);
    }

    if (recipe_label.bioengineered_food) {
      $('#bioengineered-food-toggle').trigger("click");
    }

    if (recipe_label.compact_vitamins) {
      $('#compact-vitamins').trigger("click");
    }

    applyTextStyles(recipe_label);
  }

  async function applySavedLabelFormat() {
    const updateSettings = async () => {
      if (recipe_label.show_caloric_conversion) {
        $('#conversiontoggle').trigger("click");
      }
      if (recipe_label.move_footnote) {
        $('#asterisksectiontoggle').trigger("click");
      }
      if (recipe_label.shorten_footnote) {
        $('#asterisksectionminitoggle').trigger("click");
      }
      if (recipe_label.varied_servings) {
        $('#servings-varied-toggle').trigger("click");
      }
      if (recipe_label.single_serving) {
        $('#single-serving-toggle').trigger("click");
      }
      if (recipe_label.disable_dual_column) {
        $('#disable-dual-column-toggle').trigger("click");
      }

      if (recipe_label.text_color != null) {
        $('#regularlabel-color').val(recipe_label.text_color);
        $('#regularlabel-textcolor-update').trigger("click");
      }
      if (recipe_label.background_color != null) {
        $('#regularlabel-backgroundcolor').val(recipe_label.background_color);
        $('#regularlabel-backgroundcolor-update').trigger("click");
      }

      if (recipe_label.transparent_background) {
        $('#regularlabel-transparentbackground').trigger("click");
      }

      updateVitaminToggles({ rebuildFunction });

      initOptionalNutrientPanel(recipe_label);

      if (recipe_label.show_insignificant) {
        insignificantCheckboxForFormat()?.trigger("click");
      }

      /* Other formats allow multiple locales */
      if (localesEqual(["fr-CA", "en-CA"])) {
        $('#reverse-language-toggle').trigger("click");
      }

      if (localesEqual(["en-CA"])) {
        clickUnlessChecked('#canada-english-only-toggle');
      } else if (localesEqual(["fr-CA"])) {
        clickUnlessChecked('#canada-french-only-toggle');
      }
    };

    const update = async () => {
      withoutFx(() => {
        // On the load of the initial page, fire the labeltype change callbacks so
        // that it catches things like New Linear font-size and so on.
        if ($('#labeltype').length > 0) {
          labeltype_change_callbacks();
        }

        updateSettings();
        loadSliders({ sliders });
        applyNonLabelSpecificSettings();
        showAggregateRecipeTitles();
        showOpenSections();
      });

      setSaveEnabled();
      readySignal();
    };

    /* we don't need to `await` this: we want it to occur async */
    update();
  }

  initializeSections();

  initializeSliders({
    saveSliderEvent,
    rebuildFunction,
    adjustDailyValueHeight,
    adjustServingFontSize,
    adjustDualServingSizeLineHeight,
    adjustNewLinearLineHeightForCalorieFont,
  });

  initializeTextControls();
  initializeAPDescriptionControls();
  initializeAggregateControls();
  initializeBilingualBreadcumbControl();
  showLanguages(); // Ensure bilingual elements are properly shown/hidden on page load
  initializeVitaminToggles({ rebuildFunction });

  initializeAddresses();

  initializeEmbedCode();
  exposeWidth();

  bindOverrides();

  if (canSave() || isRenderingSampleLabel()) {
    if (canSave()) {
      setSaveEnabled(false);
    }
    applySavedLabelFormat();
    /* applySavedLabelFormat invokes readySignal when loaded */
  } else {
    readySignal();
  }
};

window.initializeToggles = initializeToggles;
$(initializeToggles);
